<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="container mt-4">
      <div *ngFor="let section of responseData" class="mb-4">

        <div class="row">

          <!-- Section Title -->
          <div class="card-title">
            <h1>{{ section.sectionTitle }}</h1>
          </div>

          <!-- Questions in Section -->
          <div [formGroupName]="section.sectionTitle">
            <div *ngFor="let question of section.questions" class="mb-3">
              <ng-container [ngSwitch]="question.inputType">

                <!-- Radio Button -->
                <div *ngSwitchCase="'radio'">
                  <!--<label class="form-label">
      {{ question.questionId }} : {{ question.questionText }}
    </label>-->
                  <!--<div class="form-check" *ngFor="let option of question.optionsList">
      <input type="radio" [formControlName]="'question_' + question.questionId"
             [value]="option.value" class="form-check-input"
             id="{{ 'radio_' + question.questionId + '_' + option.value }}" />
      <label for="{{ 'radio_' + question.questionId + '_' + option.value }}">
        {{ option.label }}
      </label>
    </div>-->

                  <div *ngSwitchCase="'radio'">
                    <label class="form-label">
                      {{ question.questionId }} : {{ question.questionText }}
                    </label>
                    <p>
                      <strong>{{ form.get(section.sectionTitle)?.get('question_' + question.questionId)?.value }}</strong>
                    </p>
                  </div>

                </div>

                <!-- Text Input -->
                <div *ngSwitchCase="'text'">
                  <label class="form-label">
                    {{ question.questionId }} : {{ question.questionText }}
                  </label>
                  <input type="text" [formControlName]="'question_' + question.questionId" class="form-control" readonly />
                </div>

                <!-- Dropdown -->
                <div *ngSwitchCase="'dropdown'">
                  <label class="form-label">
                    {{ question.questionId }} : {{ question.questionText }}
                  </label>
                  <select [formControlName]="'question_' + question.questionId" class="form-select">
                    <option *ngFor="let option of question.optionsList" [value]="option.value" disabled>
                      {{ option.label }}
                    </option>
                  </select>
                </div>

               

                <!-- Other Input Types (Slider, Multi-select, etc.) -->
                <div *ngSwitchCase="'slider'">
                  <label class="form-label">
                    {{ question.questionId }} : {{ question.questionText }}
                  </label>
                  <input type="range"
                         [min]="question.min"
                         [max]="question.max"
                         step="1"
                         class="form-range"
                         [value]="form.get(section.sectionTitle)?.get('question_' + question.questionId)?.value"
                         disabled />
                  <!-- Display selected value -->
                  <span class="ms-2">
                    ₹ {{ form.get(section.sectionTitle)?.get('question_' + question.questionId)?.value }}/-
                  </span>
                </div>

                <div *ngSwitchCase="'multiselect'">
                  <label class="form-label">
                    {{ question.questionId }} : {{ question.questionText }}
                  </label>

                  <div>
                    <b> Selected Values:</b>
                    <div *ngFor="let label of question.answer; let last = last" class="ml-3">
                      {{ label }}<span *ngIf="!last">,</span>
                    </div>
                  </div>

                </div>

              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <!--<div class="text-center mt-4">
        <button type="submit" class="btn btn-success">Submit</button>
      </div>-->

    </form>
  </div>
</div>
